import { useState, useEffect } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import RestoreIcon from "@mui/icons-material/Restore";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ArchiveIcon from "@mui/icons-material/Archive";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Fab from "@mui/material/Fab";
import EditIcon from "@mui/icons-material/Edit";
import CardMenu from "./EditCardMenu";
import { toast } from "react-toastify";
import { customToastify } from "../../../utils/utils";
import ViewCarouselIcon from "@mui/icons-material/ViewCarousel";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import { Typography, IconButton, Divider, Box } from "@mui/material";
import TextField from "@mui/material/TextField";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export default function FrontCard(props) {
  const { pickCard, handleEditedItems } = props;
  const [cardData, setCardData] = useState("");

  const handleData = (secendLoad, value) => {
    setCardData(value);
    if (secendLoad) handleEditedItems({ frontCard: value });
  };
  useEffect(() => {
    handleData(false, pickCard["frontCard"]);
  }, []);

  return (
    <Item>
      <TextField
        id="filled-textarea"
        value={cardData}
        onChange={(e) => {
          handleData(true, e.target.value);
        }}
        multiline
        variant="filled"
      />
    </Item>
  );
}
